const healthyHabitsStore = {
	namespaced: true,
	state: {
		showMeasurableInputModal: false,
		showGoalCompletedModal: false,
		showTableLegendModal: false,
		showCalendarLegendModal: false,
		hideLoadingIcon: false,
		bestStreak: 0,
		historyPatientId: null,
		isReadOnlyView: false,
		mobileSizeLimit: 510,
		itemSelected: {
			date: null,
			currentValue: null,
			newValue: null,
			measureUnit: null,
			fromCalendar: false
		},
		setting: {
			nick: null,
			habitUserId: null,
			showModal: false,
			notifications: {
				email: null,
				phone: null
			},
			showStoredHabits: false,
			showGoalCompletedHabits: false,
			invertedCalendarDays: null,
			allowFreeDays: true,
			isProfessional: false,
			imageData: null
		},
		predefinedHabit: {
			startIndex: 0,
			endIndex: null,
			hideRightArrow: false,
			hideLeftArrow: true,
			itemIdSelected: null
		},
		form: {
			show: false,
			editing: false,
			predefinedHabit: null,
			multiUser: false
		},
		chart: {
			title: null,
			question: null,
			notes: null,
			reminder: null,
			reminderDays: null,
			color: null,
			history: {
				key: 0,
				options: {},
				interval: 1
			},
			frequency: {
				options: {}
			},
			score: {
				key: 0,
				options: {},
				dataCache: [],
				interval: 0,
				currentValue: 0
			},
			showChart: false,
			goalFrequencyId: null,
			goal: null,
			goalCompleted: null,
			measurable: false,
			measureUnit: null,
			total: 0,
			data: [],
			dataMapped: null
		},
		table: {
			itemSelectedId: null,
			updatingItem: false,
			minDate: null,
			maxDate: null,
			minDateServer: null,
			maxDateServer: null,
			limitDate: null,
			prevDates: true,
			key: 1,
			currentMonth: null,
			data: {}
		}
	}
}

export default healthyHabitsStore


// WEBPACK FOOTER //
// ./src/store/modules/healthyHabits.js